export const GET_LEGACY_ACCOUNTING_DOCUMENTS_BY_FLAT = 'GET_LEGACY_ACCOUNTING_DOCUMENTS_BY_FLAT'
export const CREATE_LEGACY_ACCOUNTING_DOCUMENTS = 'CREATE_LEGACY_ACCOUNTING_DOCUMENTS'
export const REMOVE_LEGACY_ACCOUNTING_DOCUMENTS = 'REMOVE_LEGACY_ACCOUNTING_DOCUMENTS'
